import _ from 'lodash';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import orange from '@material-ui/core/colors/orange';
import { getLegs as getDeliveryLegs, loadingNumberField, MAX_LEGS } from './deliveryLegs';

const numberSort = {
	r: 10,
	g: 20,
	o: 30,
};

export const version = '40.0.2';

export const sortStationsByNumber = (stations, order = 'asc') => {
	return _.orderBy(
		stations,
		function (o) {
			if (!o.number) {
				return '99';
			}
			const firstChar = o.number.toLowerCase().charAt(0);
			return (numberSort[firstChar] || 98) + '_' + o.number;
		},
		[order]
	);
};

export const sortStationTable = ({ rows, orderBy, order }) => {
	let sortedData;
	if (orderBy === 'number') {
		sortedData = sortStationsByNumber(rows, order);
	} else {
		if (order === 'desc') {
			sortedData = rows.sort((a, b) => {
				if (b[orderBy] === '-') {
					return -1;
				}
				if (a[orderBy] === '-') {
					return 1;
				}
				return b[orderBy] < a[orderBy] ? -1 : 1;
			});
		} else {
			sortedData = rows.sort((a, b) => {
				if (a[orderBy] === '-') {
					return -1;
				}
				if (b[orderBy] === '-') {
					return 1;
				}
				return a[orderBy] < b[orderBy] ? -1 : 1;
			});
		}
	}
	return sortedData;
};

export const sortTable = ({ data, order, orderBy }) => {
	return order === 'desc'
		? data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
		: data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
};

export const doesStationMatchFilter = ({ search, station }) => {
	const cleanSearch = search.replace(/[^a-z0-9 ]/gi, '');
	const re = new RegExp('\\b' + cleanSearch, 'gi');
	const fullRe = new RegExp(cleanSearch, 'gi');
	const { number, name } = station;
	return re.test(number) || re.test(name) || fullRe.test(name);
};

/*
export const isFiltered = ({search, data, fields }) => {
	if (!search) { return false; }
	const cleanSearch = search.replace(/[^a-z0-9]/gi,'');
	const re = new RegExp('\\b' + cleanSearch, 'gi');
	return !_.some(fields, field => {
		return re.test(data[field]);
	});
};
 */

export const isFiltered = ({ search, data, fields }) => {
	if (!search) {
		return false;
	}
	if (search.length <= 2) {
		return false;
	}

	function escapeRegExp(s) {
		return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	const words = search
		.split(/\s+/g)
		.map((s) => s.trim())
		.filter((s) => !!s);
	const hasTrailingSpace = search.endsWith(' ');
	const searchRegex = new RegExp(
		words
			.map((word, i) => {
				if (i + 1 === words.length && !hasTrailingSpace) {
					// The last word - ok with the word being "startswith"-like
					return `(?=.*\\b${escapeRegExp(word)})`;
				} else {
					// Not the last word - expect the whole word exactly
					return `(?=.*\\b${escapeRegExp(word)}\\b)`;
				}
			})
			.join('') + '.+',
		'gi'
	);

	return !_.some(fields, (field) => {
		//return list.filter(item => {
		return searchRegex.test(data[field]);
		//});

		//return re.test(data[field]);
	});
};

const styles = {
	phone: {
		paddingRight: 15,
	},
	phoneLabel: {
		textTransform: 'uppercase',
		fontSize: 12,
		paddingRight: 4,
		color: '#666',
	},
};

export const formatPrimaryContact = (contact) => {
	if (!contact) {
		return null;
	}
	return (
		<div>
			<div>
				{contact.name} {contact.title ? `- ${contact.title}` : ''}
			</div>
			<div style={{ paddingTop: 3 }}>
				{formatPhone('Office', contact.officePhoneNumber)}
				{formatPhone('Mobile', contact.mobilePhoneNumber)}
			</div>
		</div>
	);
};

function formatPhone(label, phoneNumber) {
	if (!phoneNumber) {
		return null;
	}
	return (
		<span style={styles.phone}>
			<span style={styles.phoneLabel}>{label}</span>
			<span>{phoneNumber}</span>
		</span>
	);
}

export const formatDeliveryWindow = (p) => {
	const { deliveryWindowStartDateTime, deliveryWindowEndDateTime, allDayWindow } = p;

	const start = moment(deliveryWindowStartDateTime);
	const end = moment(deliveryWindowEndDateTime);

	let dateTime;
	const noWrap = { whiteSpace: 'nowrap' };

	if (allDayWindow) {
		dateTime = (
			<div>
				<div style={noWrap}>{start.format('ddd M/D')}</div>
				<div style={noWrap}>All day</div>
			</div>
		);
	} else if (start.date() === end.date()) {
		const firstTime = start.minute() === 0 ? start.format('h') : start.format('h:mm');

		const secondTime = end.minute() === 0 ? end.format('h') : end.format('h:mm');

		let time;
		const sampm = start.format('a');
		const eampm = end.format('a');

		if (sampm === eampm) {
			time = `(${firstTime} - ${secondTime} ${sampm})`;
		} else {
			time = `(${firstTime} ${sampm} - ${secondTime} ${eampm})`;
		}

		dateTime = (
			<div>
				<div style={noWrap}>{start.format('ddd M/D')}</div>
				<div style={noWrap}>{time}</div>
			</div>
		);
	} else {
		dateTime = (
			<div>
				<div style={noWrap}>{start.format('ddd M/D h:mm a')} -</div>
				<div style={noWrap}>{end.format('ddd M/D h:mm a')}</div>
			</div>
		);
	}
	return dateTime;
};

export const getDeliveryWindowStartEnd = (p) => {
	const { deliveryWindowStartDateTime, deliveryWindowEndDateTime, allDayWindow } = p;

	let startMoment = moment(deliveryWindowStartDateTime);
	let endMoment = moment(deliveryWindowEndDateTime);
	if (allDayWindow) {
		endMoment = moment(startMoment).set('hour', 23).setMinute(59);
	}
	return { startMoment, endMoment };
};

const subStyle = {
	fontWeight: 300,
	fontSize: 11,
	color: '#666',
};

const statusMapping = {
	pendingSupplierLoadingNumbers: {
		statusDisplay: (
			<Fragment>
				<div>Pending Supplier</div>
				<div style={subStyle}>(Loading Numbers)</div>
			</Fragment>
		),
		statusClassName: 'pending',
	},
	pendingCarrierConfirmation: {
		statusDisplay: 'Pending Carrier',
		statusClassName: 'pending',
	},
	pendingSupplierConfirmation: {
		statusDisplay: (
			<Fragment>
				<div>Pending Supplier</div>
				<div style={subStyle}>(Fuel Confirm)</div>
			</Fragment>
		),
		statusClassName: 'pending',
	},
	pendingCarrierCancellationConfirmation: {
		statusDisplay: (
			<Fragment>
				<div>Pending Carrier</div>
				<div style={subStyle}>(Cancellation)</div>
			</Fragment>
		),
		statusClassName: 'pending',
	},
	pendingSupplierCancellationConfirmation: {
		statusDisplay: (
			<Fragment>
				<div>Pending Supplier</div>
				<div style={subStyle}>(Cancellation)</div>
			</Fragment>
		),
		statusClassName: 'pending',
	},
	carrierConfirmedDeliveryCancelled: {
		statusDisplay: (
			<Fragment>
				<div>Delivery Cancelled</div>
				<div style={subStyle}>(Carrier Confirmed)</div>
			</Fragment>
		),
		statusClassName: 'cancelled',
	},
	supplierConfirmedDeliveryCancelled: {
		statusDisplay: (
			<Fragment>
				<div>Delivery Cancelled</div>
				<div style={subStyle}>(All Confirmed)</div>
			</Fragment>
		),
		statusClassName: 'cancelled',
	},
	carrierConfirmed: { statusDisplay: 'Carrier Confirmed', statusClassName: 'normal' },
	supplierConfirmed: { statusDisplay: 'All Confirmed', statusClassName: 'normal' },
	veederVerified: { statusDisplay: 'Veeder Verified', statusClassName: 'verified' },
	veederPrimaryVerified: { statusDisplay: 'Half Verified (#1)', statusClassName: 'normal' },
	veederSecondaryVerified: { statusDisplay: 'Half Verified (#2)', statusClassName: 'normal' },
	veederPartiallyVerified: { statusDisplay: 'Partially Verified', statusClassName: 'normal' },
	veederMismatch: { statusDisplay: 'Veeder Mismatch', statusClassName: 'error' },
	userVerified: { statusDisplay: 'User Verified', statusClassName: 'verified' },
};

export const formatStatus = (status) => {
	return statusMapping[status]
		? statusMapping[status]
		: { statusDisplay: status, statusClassName: 'normal' };
};

export const statusClassNames = {
	pending: {
		fontWeight: 900,
		color: '#2196F3',
	},
	error: {
		fontWeight: 900,
		color: '#FF500F',
	},
	normal: {
		color: '#616161',
		fontWeight: 900,
	},
	cancelled: {
		color: orange[500],
		fontWeight: 900,
	},
	verified: {
		fontWeight: 900,
		color: '#4CAF50',
	},
};

export const validateEmail = (email) => {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

export const formatDeliveries = (p) => {
	// noinspection JSMismatchedCollectionQueryUpdate
	const {
		deliveries = [],
		stationMap,
		carrierMap,
		handleRowClick,
		search,
		isExternalLogistics,
	} = p;

	const thirtyDaysAgo = moment().subtract(30, 'days');

	return deliveries.reduce((result, delivery) => {
		const {
			stationDeliveryId,
			primaryStationId,
			//primaryTankNumber,
			primaryDeliveryAmount,
			carrierId,
			status,
			deliveryWindowStartDateTime,
			primaryProductType,
			internalNote,

			firstTerminalLoadingNumber,
			firstTerminalSecondaryLoadingNumber,
			secondTerminalLoadingNumber,
			secondTerminalSecondaryLoadingNumber,
		} = delivery;

		if (status === 'needsActivation') {
			return result;
		}

		const legs = getDeliveryLegs(delivery);
		const isMultiLeg = legs.length >= 2;

		const noWrap = { whiteSpace: 'nowrap' };
		const stations = [];
		const volumes = [];
		const ps = stationMap[primaryStationId] || { number: '???', name: 'Missing' };
		let stationSort = 99;

		let primaryStationName = '';
		let secondaryStationName = '';
		if (!ps) {
			stations.push(`?? - ??`);
			volumes.push(`?? - ${primaryDeliveryAmount}`);
		} else {
			stations.push(`${ps.number} - ${ps.name}`);
			primaryStationName = `${ps.number} - ${ps.name}`;

			if (isMultiLeg) {
				volumes.push(`${ps.number} : ${primaryDeliveryAmount}`);
			} else {
				volumes.push(`${primaryDeliveryAmount}`);
			}
			const firstChar = ps.number.toLowerCase().charAt(0);
			stationSort = (numberSort[firstChar] || 98) + '_' + ps.number;
		}

		//- Every stop past the first
		const extraStationNames = [];
		legs
			.filter((leg) => leg.legNumber >= 2)
			.forEach((leg) => {
				const ss = stationMap[leg.stationId] || { number: '???', name: 'Missing' };
				stations.push(`${ss.number} - ${ss.name}`);
				extraStationNames.push(`${ss.number} - ${ss.name}`);
				volumes.push(`${ss.number} : ${leg.deliveryAmount}`);
			});
		secondaryStationName = extraStationNames.join(' | ');

		let stationNode = (
			<div>
				{stations.map((st, i) => {
					return <div key={i}>{st}</div>;
				})}
			</div>
		);

		let volumeNode = (
			<div>
				{volumes.map((v, i) => {
					return (
						<div style={noWrap} key={i}>
							{v}
						</div>
					);
				})}
			</div>
		);

		const carrier = carrierMap[carrierId];
		const carrierName = (
			<div>
				<div>{carrier ? carrier.name : '??'}</div>
			</div>
		);

		const { statusClassName, statusDisplay } = formatStatus(status);
		const dateTime = formatDeliveryWindow(delivery);
		const start = moment(deliveryWindowStartDateTime);
		if (isExternalLogistics) {
			if (start.isBefore(thirtyDaysAgo)) {
				return result;
			}
		}

		const loadingNumbers = [];
		['firstTerminal', 'secondTerminal'].forEach((terminalPrefix) => {
			for (let legNumber = 1; legNumber <= MAX_LEGS; legNumber++) {
				const value = delivery[loadingNumberField(terminalPrefix, legNumber)];
				if (value) {
					loadingNumbers.push(value);
				}
			}
		});

		const row = {
			primaryProductType: primaryProductType.toUpperCase(),
			stationDeliveryId,
			stations: stationNode,
			dateTime,
			volumes: volumeNode,
			statusDisplay,
			statusClassName,
			carrierName,

			//- for sorting
			primaryDeliveryAmount,
			dateSort: start.unix(),
			rowClick: () => handleRowClick(stationDeliveryId),
			stationSort,

			primaryStationName,
			secondaryStationName,
			carrierSearch: carrier.name,
			internalNote,
			loadingNumbers,
			loadingNumbersSearch: loadingNumbers.join(' '),
			firstTerminalLoadingNumber,
			firstTerminalSecondaryLoadingNumber,
			secondTerminalLoadingNumber,
			secondTerminalSecondaryLoadingNumber,
		};

		if (
			isFiltered({
				search,
				data: row,
				fields: [
					'stationDeliveryId',
					'primaryStationName',
					'secondaryStationName',
					'carrierSearch',
				],
			})
		) {
			return result;
		}
		result.push(row);
		return result;
	}, []);
};

export class PureRecordRow extends Component {
	shouldComponentUpdate(nextProps, nextState) {
		return (
			_.get(this, 'state.hovered') !== _.get(nextState, 'hovered') ||
			this.props.selected !== nextProps.selected ||
			this.props.refreshId !== nextProps.refreshId
		);
	}

	render() {
		//const {...other} = this.props
		const { hover, className, children } = this.props;
		return (
			<TableRow hover={hover} className={className}>
				{children}
			</TableRow>
		);
	}
}

PureRecordRow.propTypes = {
	selected: PropTypes.bool,
	refreshId: PropTypes.string,
	hover: PropTypes.bool,
	className: PropTypes.string,
	authUser: PropTypes.object,
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
